/**
 * Client-side visual v2 gate. Prefer Vite env; fall back to process.env for tests.
 */
export function isStudioVisualV2ClientEnabled(): boolean {
  try {
    if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APT_STUDIO_VISUAL_V2_ENABLED === 'true') {
      return true;
    }
  } catch {
    // import.meta unavailable in some Jest contexts
  }
  return process.env.VITE_APT_STUDIO_VISUAL_V2_ENABLED === 'true'
    || process.env.APT_STUDIO_VISUAL_V2_ENABLED === 'true';
}

export function isStudioBuilderV2ClientEnabled(): boolean {
  try {
    if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APT_STUDIO_BUILDER_V2_ENABLED === 'true') {
      return true;
    }
  } catch {
    // ignore
  }
  return process.env.VITE_APT_STUDIO_BUILDER_V2_ENABLED === 'true';
}
